module.exports = __webpack_public_path__ + "static/media/w-logo.3cd591e7.png";